import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import useApi from 'hooks/useApi';
import { getDocumentDetails } from 'redux/actions/documentActions';
import { saveAlert } from 'redux/actions/notificationActions';

import AlertModal from 'shared/components/AlertModal';

import { NotifiFormWrapper } from './styles';
import Form from './Form';

const NotifiForm = ({ onCancel }) => {
  const dispatch = useDispatch();
  const { customAreaApi } = useApi();
  const { t } = useTranslation();
  const { cusNavId, isCustomer, clientId } = useSelector((state) => state.auth);
  const { searchValue } = useSelector((state) => state.topBar);
  const currentClient = useSelector((state) => state.clientState?.currentClient);
  const documentState = useSelector((state) => state.document);
  const [showSuccessSave, setShowSuccessSave] = useState();
  const [showError, setShowError] = useState(false);

  const [, createNotification] = customAreaApi(
    {
      url: `${window.API_V1}/cli/items/${cusNavId}/${
        isCustomer ? searchValue || currentClient?.clientId : clientId
      }/${documentState.documentDtails?.id}/alert`,
      method: 'POST',
    },
    { manual: true }
  );

  const [, modifyNotification] = customAreaApi(
    {
      url: `${window.API_V1}/cli/items/${cusNavId}/${
        isCustomer ? searchValue || currentClient?.clientId : clientId
      }/${documentState.documentDtails?.id}/alert/modify`,
      method: 'POST',
    },
    { manual: true }
  );

  const onToggleError = () => setShowError((currentShow) => !currentShow);

  const onToggleSuccessSave = () => setShowSuccessSave((currentShow) => !currentShow);

  const onCreateNotification = async (values) => {
    try {
      const newData = {
        title: values.title,
        date: moment(values.date).toISOString(),
        description: values.description,
      };
      const {
        data: { data },
      } = await createNotification({ data: newData });
      onToggleSuccessSave();
      if (!data) {
        throw new Error(
          data.reduce((actual, current) => `${actual}\n${current.message}`),
          ''
        );
      }
    } catch (error) {
      setShowError(true);
    }
  };

  const onModifyNotification = async (values) => {
    const { alerts } = documentState.documentDtails;
    try {
      const newData = {
        id: alerts[0].id,
        title: values.title,
        date: moment(values.date).toISOString(),
        description: values.description,
      };
      const {
        data: { data },
      } = await modifyNotification({ data: newData });
      onToggleSuccessSave();
      if (!data) {
        throw new Error(
          data.reduce((actual, current) => `${actual}\n${current.message}`),
          ''
        );
      }
    } catch (error) {
      setShowError(true);
    }
  };

  const onSaveNotification = (values) => {
    const { alerts } = documentState.documentDtails;
    if (alerts?.length > 0) {
      onModifyNotification(values);
    } else {
      onCreateNotification(values);
    }
  };

  const onOkSuccessSave = () => {
    onToggleSuccessSave();
    dispatch(getDocumentDetails(null));
    dispatch(saveAlert(true));
    onCancel();
  };

  const Title = () => {
    return (
      <Row className="row-title">
        <Col sm={12} className="ml-n3">
          <h3>
            {t(
              documentState.documentDtails?.alerts?.length > 0
                ? 'notification_title_alert_modify'
                : 'notification_alert_title_add'
            )}
          </h3>
        </Col>
      </Row>
    );
  };
  return (
    <>
      <NotifiFormWrapper>
        <Title />
        <Form onCancel={onCancel} onSubmit={onSaveNotification} />
      </NotifiFormWrapper>
      <AlertModal
        type="error"
        isOpen={showError}
        toggle={onToggleError}
        message={t('custom_field_operation_error_message')}
        okText={t('general_button_ok')}
        onOk={onToggleError}
      />
      <AlertModal
        type="success"
        isOpen={showSuccessSave}
        toggle={onOkSuccessSave}
        message={t('custom_feild_save_document_field_success')}
        okText={t('general_button_ok')}
        onOk={onOkSuccessSave}
      />
    </>
  );
};

NotifiForm.defaultProps = {};

NotifiForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default NotifiForm;
